import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 产品发布一级
const productionRouter: RouteConfig = {
  path: '/production',
  component: Layout,
  redirect: '/production/production-ios/production-ios-list',
  meta: {
    title: '产品发布',
    icon: 'menu-production'
  },
  children: [
    {
      name: 'productionIos',
      path: 'production-ios',
      component: () => import('@/views/production/production-ios/index.vue'),
      redirect: '/production/production-ios/production-ios-list',
      meta: {
        title: 'iOS'
      },
      children: [
        {
          name: 'ProductionIosList',
          path: 'production-ios-list',
          component: () => import('@/views/production/production-ios/list.vue'),
          meta: {
            title: '产品发布列表'
          }
        },
        {
          name: 'ProductionIosAdd',
          path: 'production-ios-add',
          component: () => import('@/views/production/production-ios/add.vue'),
          meta: {
            title: '产品信息新增',
            showTitle: true
          }
        },
        {
          name: 'ProductionIosEdit',
          path: 'production-ios-edit',
          component: () => import('@/views/production/production-ios/edit.vue'),
          meta: {
            title: '产品信息编辑',
            showTitle: true
          }
        },
        {
          name: 'ProductionIosView',
          path: 'production-ios-view',
          component: () => import('@/views/production/production-ios/view.vue'),
          meta: {
            title: '产品信息查看',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'productionAndroid',
      path: 'production-android',
      component: () => import('@/views/production/production-android/index.vue'),
      redirect: '/production/production-android/production-android-list',
      meta: {
        title: '安卓'
      },
      children: [
        {
          name: 'ProductionAndroidList',
          path: 'production-android-list',
          component: () => import('@/views/production/production-android/list.vue'),
          meta: {
            title: '产品发布列表'
          }
        },
        {
          name: 'ProductionAndroidAdd',
          path: 'production-android-add',
          component: () => import('@/views/production/production-android/add.vue'),
          meta: {
            title: '产品信息添加',
            showTitle: true
          }
        },
        {
          name: 'ProductionAndroidEdit',
          path: 'production-android-edit',
          component: () => import('@/views/production/production-android/edit.vue'),
          meta: {
            title: '产品信息编辑/查看',
            showTitle: true
          }
        },
        {
          name: 'ProductionAndroidView',
          path: 'production-android-view',
          component: () => import('@/views/production/production-android/view.vue'),
          meta: {
            title: '产品信息查看',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'productionPC',
      path: 'production-pc',
      component: () => import('@/views/production/production-pc/index.vue'),
      redirect: '/production/production-pc/production-pc-list',
      meta: {
        title: 'PC'
      },
      children: [
        {
          name: 'ProductionPCList',
          path: 'production-pc-list',
          component: () => import('@/views/production/production-pc/list.vue'),
          meta: {
            title: '兔兔PC版本列表'
          }
        },
        {
          name: 'ProductionPCAdd',
          path: 'production-pc-add',
          component: () => import('@/views/production/production-pc/add.vue'),
          meta: {
            title: '产品信息添加',
            showTitle: true
          }
        },
        {
          name: 'ProductionPCEdit',
          path: 'production-pc-edit',
          component: () => import('@/views/production/production-pc/edit.vue'),
          meta: {
            title: '产品信息编辑/查看',
            showTitle: true
          }
        },
        {
          name: 'ProductionPCView',
          path: 'production-pc-view',
          component: () => import('@/views/production/production-pc/view.vue'),
          meta: {
            title: '产品信息查看',
            showTitle: true
          }
        }
      ]
    }
  ]
}

export default productionRouter
